const TokenKey = 'Admin-Token'

export function getToken() {
    return window.self.localStorage.getItem(TokenKey)
}

export function setToken(token) {
    return window.self.localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    return window.self.localStorage.removeItem(TokenKey)
}
